import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import MDButton from "components/MDButton";
import React from "react";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";

export default function CopyTemplateModal({ closeModal }) {
  const { modalData = {}, isLoading = false } = useSelector((state) => state.modal);
  const { copyHandler, templateId } = modalData;

  const handleCopy = async () => {
    if (typeof copyHandler === "function") {
      await copyHandler(templateId);
    }
  };

  return (
    <>
      <DialogTitle display="flex" alignItems="center" justifyContent="space-between">
        Copy Template
        <IconButton onClick={closeModal} edge="end" size="small">
          <CloseIcon fontSize="medium" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to copy this template to refill template?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={closeModal} size="small" color="secondary">
          Cancel
        </MDButton>
        <MDButton onClick={handleCopy} size="small" color="primary">
          {isLoading ? <CircularProgress size={16} color="inherit" /> : "Yes, Copy"}
        </MDButton>
      </DialogActions>
    </>
  );
}
